import React from "react";
import styles from "./CustomButton.module.css";

interface CustomButtonProps {
  height?: string;
  width?: string;
  flexGrow?: number;
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: string;
  fontWeight?: number | string;
  fontSize?: string;
  fontColor?: string;
  onClick: () => void;
  children: React.ReactNode;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  height = "44px",
  width = "86px",
  flexGrow = 0,
  backgroundColor = "#00c6b1",
  borderColor = "#00c6b1",
  borderRadius = "5px",
  fontWeight = 550,
  fontSize = "16px",
  fontColor = "#ffffff",
  onClick,
  children,
}) => {
  const buttonStyle: React.CSSProperties = {
    height,
    width,
    flexGrow,
    backgroundColor,
    borderColor,
    borderRadius,
    fontWeight: typeof fontWeight === "number" ? fontWeight : parseInt(fontWeight),
    fontSize,
    color: fontColor,
  };

  return (
    <button
      className={styles["button-common-styles"]}
      style={buttonStyle}
      onClick={onClick}
    >
    <span
      className={styles["button-text"]}
      style={{
        fontWeight:
          typeof fontWeight === "number" || fontWeight === "normal" || fontWeight === "bold"
            ? fontWeight
            : undefined,
      }}
    >
      {children}
    </span>
    </button>
  );
};

export default CustomButton;
